<template>
  <div class="piano-coltivazione-mobile">
    <!-- Contenuto Mobile -->
  </div>
</template>

<script>
export default {
  name: "PianoColtivazioneMobile",
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeDestroy() {}
};
</script>


